module.exports = __webpack_public_path__ + "static/media/01.30e7c244.png";